var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonalien(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "24px",
    viewBox: "0 0 26 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFD7-Grundlagen:-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-953.000000, -2486.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atom/icon/24px/personalien",
    transform: "translate(954.000000, 2486.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Card-Outline",
    stroke: "#145685",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x: 0,
    y: 4,
    width: 24,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,17 C12,15 10.3125,13 7.5,13 C4.6875,13 3,15 3,17 L12,17 Z",
    id: "K\\xF6rper",
    fill: "#145685"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Kopf",
    fill: "#145685",
    cx: 7.5,
    cy: 9.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 8,
    x2: 20,
    y2: 8,
    id: "Line-2",
    stroke: "#145685",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 12,
    x2: 20,
    y2: 12,
    id: "Line-1",
    stroke: "#145685",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalien);
export default __webpack_public_path__ + "static/media/personalien.65c7dbe7bbe30a4287f6bbf4729175a4.svg";
export { ForwardRef as ReactComponent };